import { SupportedLanguages } from "../common/controls/lang-switcher";
import { localesKeys__SkillsChart } from "../common/skills-chart/locales";
import { localesKeys__RightSwitcher } from "../modules/sunday-top-nav/buttons/right-toggle/locales";
import { localesKeys__Navigation } from "../routes/locales";

export const USER_LANG_KEY: string = 'volobuev-cv-site-locale';

export type ILanguageDictionary = {
  [language in SupportedLanguages]: MergeTranslateKeys;
};

export type TranslatedKey = keyof MergeTranslateKeys;

export type MergeTranslateKeys = localesKeys__SkillsChart 
& localesKeys__RightSwitcher 
& localesKeys__Navigation
& {
  cardAbout_label: string;
};